import React, { Fragment } from 'react'
import { Intro, Button, Scoreboard } from 'cvs-core'
import introImg from '../../assets/images/U2-T1-1-12a.svg'

export default {
  title: 'Complete',
  path: '/complete',
  content: (
    <Fragment>
      <Intro
        title="Congratulations!"
        lead="You have learned so much about how to live vape free and help others do the same. Use this information to make healthy choices!"
      />

      <img
        className="intro__img--complete"
        src={introImg}
        alt="certificate"
        width="568"
        height="235"
      />
      <div className="cvs-completion">
        <Scoreboard />

        <Button
          classes={{
            'cert-download': true,
          }}
          children="Download Certificate"
          file={process.env.PUBLIC_URL + '/CVS-BVF-HS-SPM-certificate.pdf'}
        />
      </div>
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/certificate/Complete.js